import { Box } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Bar } from 'react-chartjs-2'
import { makeGetRequest } from 'utils/api'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)
const color_list = [
  '#60829b',
  '#0dcaf0',
  '#307757',
  '#d63384',
  '#fd7e14',
  '#60829b',
  '#0dcaf0',
  '#307757',
  '#d63384',
  '#fd7e14',
  '#60829b',
  '#0dcaf0',
  '#307757',
  '#d63384',
  '#fd7e14',
  '#60829b',
  '#0dcaf0',
  '#307757',
  '#d63384',
  '#fd7e14',
  '#60829b',
  '#0dcaf0',
  '#307757',
  '#d63384',
  '#fd7e14',
]

export default function Chart2({ classificationSelected }) {
  const { t, i18n } = useTranslation('layout') // LAP-733 (GE022)
  const [dataSet, setDataSet] = useState({
    labels: [classificationSelected],
    datasets: [
      {
        label: '',
        data: [],
        backgroundColor: ['#fd7e14'],
        borderColor: ['#fd7e14'],
        barThickness: 20,
      },
    ],
  })

  useEffect(() => {
    fetchData(classificationSelected)
    // LAP-733 (GE022) — re-run on locale change to refresh series labels
  }, [classificationSelected, i18n.language])

  const fetchData = async () => {
    const response = await makeGetRequest(
      '/api/Finance/sous-cat-chart1/?classification=' + classificationSelected,
      {},
      true,
    )
    if (response.status === 200) {
      let labels = response.data.labels
      let data = response.data.data
      let datasets = []
      labels.forEach((v, index) => {
        datasets.push({
          label: v,
          data: [data[index]],
          backgroundColor: color_list[index],
          borderColor: color_list[index],
          barThickness: 20,
        })
      })
      datasets.push({
        label: t('finance.monBudget.objectivesPlural'), // LAP-733 (GE022)
        data: [],
        backgroundColor: ['red'],
        borderColor: ['red'],
        barThickness: 20,
      })
      setDataSet({
        labels: [classificationSelected],
        datasets: datasets,
      })
    }
  }

  const options = {
    indexAxis: 'x',
    responsive: true,
    aspectRatio: 1,
    maintainAspectRatio: false,

    plugins: {
      title: {
        display: false,
        position: 'bottom',
        text: 'Dépense nécesarie fixe',
      },
      datalabels: {
        display: false,
      },
      legend: {
        position: 'right',
      },
    },

    scales: {
      x: {
        stacked: true,
        ticks: { color: 'white' },
      },
      y: {
        stacked: true,
        ticks: { color: 'white' },
      },
    },
  }
  const plugins = [
    {
      id: 'shapDraw',
      afterDraw(chart) {
        var ctx = chart.ctx
        var xAxis = chart.scales['x']
        var yAxis = chart.scales['y']

        chart.data.datasets.forEach(function (dataset, datasetIndex) {
          var meta = chart.getDatasetMeta(datasetIndex)
          if (meta.hidden) return

          meta.data.forEach(function (element, index) {
            // Draw a line in the middle of each bar
            var barWidth = xAxis.getPixelForValue(index + 1) - xAxis.getPixelForValue(index)
            var x = xAxis.getPixelForValue(index) + barWidth / 2
            var yStart = yAxis.getPixelForValue(dataset.data[index])
            var yEnd = yAxis.getPixelForValue(0)

            ctx.beginPath()
            ctx.strokeStyle = 'red'
            ctx.moveTo(x, yStart)
            ctx.lineTo(x, yEnd)
            ctx.stroke()
          })
        })
      },
    },
  ]
  return (
    <Box height={350} position={'relative'} width={'100%'}>
      <Bar data={dataSet} options={options} />
    </Box>
  )
}
